<ion-header>
  <ion-toolbar>
    <ion-title>Orden de Pedido # {{order.id}}</ion-title>
    <ion-buttons slot="end">
      <ion-button color="dark" (click)="closeModal()">
          <ion-icon name="close"></ion-icon>
        </ion-button>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="infoContainer">
  <!--INFORMACION GENERAL-->
  <div class="sectionContainer">
    <h4 class="font-bold">Información general</h4>
    <p *ngIf="order.player_amount_points && order.player_amount_points != 0">
        Total: 
        <span class="priceSpan">
          <ion-icon color="primary" *ngIf="configService.company_info?.currency_icon_svg" [src]="configService.company_info?.currency_icon_svg"></ion-icon>
        {{order.player_amount_points | currency:'COP':''}} <span *ngIf="!configService.company_info?.currency_icon_svg">{{configService.company_info.points_name}}</span></span>
        <span *ngIf="(order.player_amount_points != 0) && (order.player_amount != 0)" style="padding-left: 5px;">+</span>
        <span *ngIf="order.player_amount != '0'" style="padding-left: 5px;">${{order.player_amount | currency:'COP':''}}</span>    
    </p>
    <p>Fecha: <span class="dataSpan">{{order.fixed_created_date}}</span></p>
    <p *ngIf="order.canceled_reason">Razon de cancelación: <span class="dataSpan">{{order.canceled_reason}}</span></p>
    <p>Estado: <span class="orderState_{{order.order_state}}">{{productsService.getOrderState(order)}}</span></p>
  </div>
  <!--PRODUCTOS-->
  <div class="sectionContainer">
      <h4 class="font-bold">Productos</h4>
      <div *ngFor="let product of order.products" class="productContainer">
        <span>{{product.name}}</span>
        <div class="spaceBetween">
            <div class="displayFlex">
                <img *ngIf="!product.product_images || product.product_images.length == 0" class="smallProductImage" src="assets/images/no-image.png">
                <img class="smallProductImage" *ngIf="product.product_images && product.product_images.length != 0" [src]="product?.product_images[0].image">
                <div class="reverseFlex horizontalCenter">
                  <span class="dataSpan">Cantidad: {{product.quantity}}</span>
                  <span class="priceSpan"  *ngIf="configService.company_info?.show_points">
                      <ion-icon color="primary" *ngIf="configService.company_info?.currency_icon_svg" [src]="configService.company_info?.currency_icon_svg"></ion-icon>
                    {{getPrice(product) | currency:'COP':''}} <span *ngIf="!configService.company_info?.currency_icon_svg">{{configService.company_info.points_name}}</span></span>
                    <span *ngIf="hasMoney(product)" style="padding-left: 5px;">+ ${{product.purchase.money | currency:'COP':''}}</span>
                </div>
              </div>
              <div class="reverseFlex smallSpan horizontalCenter">
                <span class="orderState_{{product.state}}">{{productsService.getProductState(product)}}</span>
                <span *ngIf="product.canceled_reason">{{product.canceled_reason}}</span>
                <span class="dataSpan">{{product.fixed_updated_date}}</span>
              </div>
        </div>
          <p *ngIf="product.link != '' && product?.name != 'SOAT'"><a target="_blank" [href]="product.link">Descargar Bono</a></p>
          <p *ngIf="product.link != '' && product?.name == 'SOAT'"><a target="_blank" [href]="product.link">Descargar SOAT</a></p>
          <p *ngIf="product.link != '' && product?.name == 'SOAT'">* Recuerda que la contraseña del pdf es la placa de tu vehículo</p>
          <p *ngIf="product.sticker"><a target="_blank" [href]="product.sticker">Descargar guía {{product.tracking_number}}</a></p>
          <p class="descriptionText smallSpan" [innerHTML]="product.description"></p>
      </div>
    </div>
    <!--DATOS DE ENTREGA-->
    <div *ngIf="order.address" class="sectionContainer">
        <h4 class="font-bold">Datos de entrega</h4>
        <p *ngIf="order.address?.address">Dirección: <span class="dataSpan">{{order.address.address}}</span></p>
        <p *ngIf="order.address?.city">Ciudad: <span class="dataSpan">{{order.address.city}}</span></p>
        <p *ngIf="order.address?.neighborhood">Barrio: <span class="dataSpan">{{order.address.neighborhood}}</span></p>
        <p *ngIf="order.address?.additional_info">Información adicional: <span class="dataSpan">{{order.address.additional_info}}</span></p>
        <p *ngIf="order.address?.name">Nombre de quien recibe: <span class="dataSpan">{{order.address.name}}</span></p>
        <p *ngIf="order.address?.cellphone">Telefono de quien recibe: <span class="dataSpan">{{order.address.cellphone}}</span></p>
      </div>
</ion-content>
